//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import kotlin.Any

public data class StartInspectionCommandInput(
  public val id: Any,
  public val templateId: Any,
  public val conductedAt: Any,
)
